var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWorkspace = function SvgWorkspace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.327a3.677 3.677 0 0 0-3.667 3.666A3.677 3.677 0 0 0 4.5 16.66a3.677 3.677 0 0 0 3.667-3.667A3.677 3.677 0 0 0 4.5 9.327ZM10 .16a3.677 3.677 0 0 0-3.667 3.667A3.677 3.677 0 0 0 10 7.493a3.677 3.677 0 0 0 3.667-3.666A3.677 3.677 0 0 0 10 .16Zm5.5 9.167a3.677 3.677 0 0 0-3.666 3.666A3.677 3.677 0 0 0 15.5 16.66a3.677 3.677 0 0 0 3.667-3.667A3.677 3.677 0 0 0 15.5 9.327Z",
    fill: "#444"
  })));
};
export default SvgWorkspace;